import { useState, useCallback, useEffect } from "react";
import throttle from "lodash.throttle";

export function useMatchMedia(queries, defaultValue) {
  const [matchedValue, setMatchedValue] = useState(null);

  function handleResize() {
    const _matchedValue = (() => {
      const filterd = queries.filter(
        (obj) => !!window.matchMedia(obj.query).matches
      );
      if (filterd.length > 0) {
        return filterd[0].value;
      } else {
        return defaultValue;
      }
    })();
    setMatchedValue(_matchedValue);
  }
  const throttleHandler = useCallback(throttle(handleResize, 300), []);

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.addEventListener("resize", throttleHandler);
      handleResize();
    }
    return () => {
      window.removeEventListener("resize", throttleHandler);
    };
  }, []);

  return matchedValue;
}
